import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pm-bulkorder',
  templateUrl: './bulkorder.component.html',
  styleUrls: ['./bulkorder.component.css']
})
export class BulkorderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
